import React from 'react';
import {Helpers} from '../../core/src/helpers';
import '../css/pdp-daas-popup.less';

class DaasPopup extends React.Component {

    constructor() {
        super();
        this.state = {
            modalOpen: true
        }
    }

    closePopup = () => {
        this.setState({
            modalOpen:false
        })
        //hpUtil.trackEvent({prefix: METRIC_PREFIX, omni: METRIC_VAR, base: 'close-popup'}); // will fire both omni event, and optimizely event
        Helpers.hpUtilTrackEvent({
            base:"close-popup",
            prefix: "SMB-DaaS-Liftforward",
            omni: "var1",
            errorMessage: `daas campaign failed to track data: close-popup`
          });
    }

    clickedPopup = () => {
        Helpers.setCookie("clickedPopup","var1",30);
    }

    clickedShop = () => {
        Helpers.hpUtilTrackEvent({
            base:"shop-pdp",
            prefix: "SMB-DaaS-Liftforward",
            omni: "var1",
            errorMessage: `daas campaign failed to track data: close-popup`
          });

          Helpers.setCookie("clickedPopup","var1",30);
    }
    
    render() {
    
    let mainImage = this.props.mainImage;
    let heroImage = mainImage && mainImage.length > 0 ? Helpers.getCDNUrl(mainImage[0].cdn,mainImage[0].lrg,200) : null;
     
    return (
        <div id="daasModal" className={`daasmodal${this.state.modalOpen ? "" : " closePopup"}`}>
            <div className="daasmodal-content"><span className="daasclose" onClick={this.closePopup}>&times;</span>
            <div className="daasmodalHeader">HP Small Business Essentials</div>
            <div className="daasmodalBody">Try product subscription for select <br/>{this.props.descOne}.
            { heroImage && <img style={{marginTop:"5px"}} src={heroImage} width="200"/> }<div className="program"><strong>Program includes:</strong>
            <br/>Low monthly payments.<br/>{this.props.descTwo}.</div>
            </div><a target="_blank" onClick={this.clickedShop} href={this.props.shopURL} className="blueback">SHOP <img src="https://storeapp-production-assets.s3.amazonaws.com/app/static/img/outgoing.png" style={{width:"18px",position:"relative",top:"3px"}}></img></a>
            <div className="disclaimer2"><img src="https://storeapp-production-assets.s3.amazonaws.com/app/static/img/outgoing2.png"/> * By clicking SHOP you will be directed to a website that has a different 
            privacy policy and information collection practice. Please make sure to read privacy policy and terms
             and conditions posted on that site. 
                </div>
            <div className="cta">
                <a id="clink" onClick={this.clickedPopup} href={`${process.env.BASENAME}/cv/smallbusinessessentials?jumpid=ma_pdp_daas_na_1_20012`}>Click</a> for program details
                </div></div></div>
        )
    }
}


export default DaasPopup;
